import { getDPR } from '../constants';

export function resizeCanvas(canvas: HTMLCanvasElement) {
  const dpr = getDPR();
  if (!canvas || !canvas.parentElement) return;
  const container = canvas.parentElement;
  canvas.width = container.clientWidth * dpr;
  canvas.height = container.clientHeight * dpr;
}
